module.exports = __webpack_public_path__ + "img/bee003.48597ae2.svg";